
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/what-is-partial-truckload-shipping",
      function () {
        return require("private-next-pages/content/what-is-partial-truckload-shipping.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/what-is-partial-truckload-shipping"])
      });
    }
  